import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import { AnomalieType } from '../../../../constants';
import { TypePiece } from '../../../../constants';

import ArticleWebLink from 'components/Shared/ArticleWebLink';
import ArticleARisquePicto from 'components/Shared/ArticleARisquePicto';

const styles = theme => ({
    cell: {
        padding: '4px 8px 4px 8px'
    },
    numericCell: {
        padding: '4px 8px 4px 8px',
        textAlign: 'right'
    },
    cellAnomalie: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.common.white,
        padding: '4px 8px 4px 8px'
    },
    numericCellAnomalie: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.common.white,
        padding: '4px 8px 4px 8px',
        textAlign: 'right'
    },
    numeroLigneCell: {
        padding: '4px 30px 4px 8px',
        textAlign: 'right'
    },
    numeroLigneCellAnomalie: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.common.white,
        padding: '4px 30px 4px 8px',
        textAlign: 'right'
    }
})

class QualificationTable extends React.Component {

    getTypeAnomalieAffichage(typeAnomalie) {
        const lstTypeAnomalieAfficherCodeArticle = [AnomalieType.ErreurProduit];
        const lstTypeAnomalieAfficherDescriptif = [AnomalieType.ErreurProduit, AnomalieType.DefautProduitManqueAccessoire, AnomalieType.DefautProduitCasse, AnomalieType.DefautProduitAspectDeballage, AnomalieType.DefautProduitPremiereUtilisation, AnomalieType.DefautApresFonctionnement];

        let result = {
            libelleQuantite: 'Quantité anomalie',
            libelleCodeArticle: 'Code article anomalie',
            libelleDescriptif: 'Description de l\'anomalie',
            libelleCommentaire: 'Commentaire',
            AfficherCodeArticle: lstTypeAnomalieAfficherCodeArticle.includes(typeAnomalie),
            AfficherDescriptif: lstTypeAnomalieAfficherDescriptif.includes(typeAnomalie)
        };

        switch (typeAnomalie) {
            case AnomalieType.QuantiteArticleIncorrecte:
                result.libelleQuantite = 'Quantité réellement reçue';
                break;
            case AnomalieType.ErreurProduit:
                result.libelleCodeArticle = 'Code article reçu à la place';
                result.libelleQuantite = 'Quantité reçue à la place';
                result.libelleDescriptif = 'Description du produit reçu';
                break
            case AnomalieType.DefautProduitManqueAccessoire:
                result.libelleQuantite = 'Quantité manquante';
                result.libelleDescriptif = 'Description de l\'accessoire manquant';
                break;
            case AnomalieType.DefautProduitAspectDeballage:
                result.libelleQuantite = 'Quantité détériorée';
                result.libelleDescriptif = 'Description de l\'élément défectueux';
                break;
            case AnomalieType.ColisAbime:
                result.libelleQuantite = 'Quantité abîmée';
                break;
            case AnomalieType.DefautProduitPremiereUtilisation:
                result.libelleQuantite = 'Quantité détériorée';
                result.libelleDescriptif = 'Défaut constaté';
                break;
            case AnomalieType.DemandeRetour:
            case AnomalieType.DemandeRetourVolontaire:
                result.libelleQuantite = 'Quantité à retourner';
                break;
            case AnomalieType.ClientPasRetirerMarchandise:
                result.libelleQuantite = 'Quantité reprise';
                break;
            default: {
                break;
            }
        }

        return result;
    }

    render() {
        let { lignes, classes, typePiece } = this.props;

        // Colonne « Pièce(s) livraison » uniquement pour un dossier créé depuis une commande.
        const afficherPiecesLivraison = typePiece === TypePiece.Commande;

        // Colonne picto « à risque » (sans titre, tout à gauche) : seulement si au moins une ligne en anomalie est à risque.
        const afficherColonneARisque = lignes && lignes.some(l => l.aRisque && l.typeAnomalie !== null);

        // DEV-4347 : colonne « Commentaire » affichée seulement si au moins une ligne en porte un.
        const afficherCommentaire = lignes && lignes.some(l => l.commentaireAnomalie && l.commentaireAnomalie.trim() !== '');

        let typeAnomalieAffichage = null;
        if (lignes && lignes.length > 0) {
            const lignesAnomalie = lignes.filter(l => l.typeAnomalie !== undefined && l.typeAnomalie !== null);
            if (lignesAnomalie.length > 0) {
                typeAnomalieAffichage = this.getTypeAnomalieAffichage(lignesAnomalie[0].typeAnomalie);
            } else {
                typeAnomalieAffichage = this.getTypeAnomalieAffichage(-1);
            }
        } else {
            typeAnomalieAffichage = this.getTypeAnomalieAffichage(-1);
        }

        return (
            <Table>
                <TableHead>
                    <TableRow>
                        {afficherColonneARisque && <TableCell className={classes.cell} />}
                        <TableCell className={classes.cell}>Numéro de ligne</TableCell>
                        <TableCell className={classes.cell}>Code article commandé</TableCell>
                        <TableCell className={classes.cell}>Désignation</TableCell>
                        <TableCell className={classes.cell}>Fournisseur</TableCell>
                        {afficherPiecesLivraison && <TableCell className={classes.cell}>Pièce(s) livraison</TableCell>}
                        <TableCell className={classes.numericCell}>Quantité commandée</TableCell>
                        <TableCell className={classes.numericCell}>Prix unitaire</TableCell>
                        {typeAnomalieAffichage.AfficherCodeArticle && <TableCell className={classes.cell}>{typeAnomalieAffichage.libelleCodeArticle}</TableCell>}
                        <TableCell className={classes.numericCell}>{typeAnomalieAffichage.libelleQuantite}</TableCell>
                        {typeAnomalieAffichage.AfficherDescriptif && <TableCell className={classes.cell}>{typeAnomalieAffichage.libelleDescriptif}</TableCell>}
                        {afficherCommentaire && <TableCell className={classes.cell}>{typeAnomalieAffichage.libelleCommentaire}</TableCell>}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {lignes && lignes.map((x, index) => (
                        <TableRow key={index}>
                            {afficherColonneARisque && (
                                <TableCell align="center" className={x.typeAnomalie !== null ? classes.cellAnomalie : classes.cell}>
                                    {x.aRisque && x.typeAnomalie !== null && (
                                        <ArticleARisquePicto color="inherit" sx={{ fontSize: 18, verticalAlign: 'middle', display: 'block', mx: 'auto' }} />
                                    )}
                                </TableCell>
                            )}
                            <TableCell className={x.typeAnomalie !== null ? classes.numeroLigneCellAnomalie : classes.numeroLigneCell}>{x.numeroLigne}</TableCell>
                            <TableCell className={x.typeAnomalie !== null ? classes.cellAnomalie : classes.cell}>
                                <Stack direction={'row'} alignItems="center">
                                    <Box sx={{ mr: 3 }}>
                                        {x.codeArticleCommande}
                                    </Box>
                                    {x.publieWeb && <ArticleWebLink reference={x.codeArticleCommande} />}
                                </Stack>
                            </TableCell>
                            <TableCell className={x.typeAnomalie !== null ? classes.cellAnomalie : classes.cell}>{x.designationArticleCommande}</TableCell>
                            <TableCell className={x.typeAnomalie !== null ? classes.cellAnomalie : classes.cell}>{x.fournisseur ? (x.fournisseur.nom || x.fournisseur.code || '') : ''}</TableCell>
                            {afficherPiecesLivraison && (
                                <TableCell className={x.typeAnomalie !== null ? classes.cellAnomalie : classes.cell}>
                                    {x.piecesLivraison
                                        ? x.piecesLivraison.split(';').map(p => <div key={p}>{p}</div>)
                                        : '--'}
                                </TableCell>
                            )}
                            <TableCell className={x.typeAnomalie !== null ? classes.numericCellAnomalie : classes.numericCell}>{x.quantiteCommande}</TableCell>
                            <TableCell className={x.typeAnomalie !== null ? classes.numericCellAnomalie : classes.numericCell}>{x.prixUnitaireCommande.toFixed(2)} €</TableCell>
                            {typeAnomalieAffichage.AfficherCodeArticle && <TableCell className={x.typeAnomalie !== null ? classes.cellAnomalie : classes.cell}>{x.codeArticleAnomalie}</TableCell>}
                            <TableCell className={x.typeAnomalie !== null ? classes.numericCellAnomalie : classes.numericCell}>{x.quantiteAnomalie}</TableCell>
                            {typeAnomalieAffichage.AfficherDescriptif && <TableCell className={x.typeAnomalie !== null ? classes.cellAnomalie : classes.cell}>{x.descriptifAnomalie}</TableCell>}
                            {afficherCommentaire && <TableCell className={x.typeAnomalie !== null ? classes.cellAnomalie : classes.cell}>{x.commentaireAnomalie}</TableCell>}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }
}

QualificationTable.propTypes = {
    lignes: PropTypes.array.isRequired,
    // Type de pièce du dossier ; en mode commande, affiche la colonne « Pièce(s) livraison ».
    typePiece: PropTypes.number
};

export default withStyles(styles)(QualificationTable);
